// node_modules
import { FC, useEffect, useRef, useState } from "react";
import { faRobot } from "@fortawesome/free-solid-svg-icons";
// Components
import { LetteredUserCircle, FindestRefTextBox } from "Components";
// Types
import { TChatMessage } from "Types";
// styles
import styles from "./chatBubble.module.scss";
import variables from "styles/colors.module.scss";
import { useIsOnScreen } from "Hooks";

type TChatContainerProps = {
    message: TChatMessage,
    messageIndex: number,
    editableChatboxPlaceholder?: string,
    onSendChatMessage?: (message: string, index: number) => void,
    messagesCount: number
};

export const ChatBubble: FC<TChatContainerProps> = ({ editableChatboxPlaceholder, message,
        onSendChatMessage, messageIndex, messagesCount }: TChatContainerProps) => {
    // State
    const [lastMessagesCount, setLastMessagesCount] = useState<number>(0);

    // Ref
    const chatBubbleMessageInputRef = useRef<HTMLInputElement>(null);
    const chatBubbleContainerRef = useRef<HTMLDivElement>(null);

    // Custom hooks
    const { isOnScreen } = useIsOnScreen(chatBubbleMessageInputRef);
        
    // Logic
    useEffect(() => {
        if (chatBubbleContainerRef &&
            chatBubbleContainerRef.current &&
                !isOnScreen &&
                messagesCount !== lastMessagesCount) {
            chatBubbleContainerRef.current.scrollIntoView();
            setLastMessagesCount(messagesCount);
        }
    }, [messagesCount, isOnScreen, message.isEditable, message.isResponse, lastMessagesCount]);

    if(!message) return null;
    
    const sendChatMessage = (chatMessage: string) => {
        if(!onSendChatMessage) return;
        onSendChatMessage(chatMessage, messageIndex);
    };

    return (
        <div ref={chatBubbleContainerRef} className={[styles.chatBubble, message.isResponse ? styles.responseChatBubble : ""].join(" ")}>
            {!message.isResponse && message.username ?
                    <div>
                        <LetteredUserCircle username={message.username} />
                    </div>
                :
                    null
            }
            {message.isEditable ?
                    <div className={[styles.messageBubble, styles.inputMessageBubble].join(" ")}>
                        <FindestRefTextBox
                            ref={chatBubbleMessageInputRef}
                            placeholder={editableChatboxPlaceholder} 
                            extraClassNameInputElement={styles.inputElement}
                            onEnter={sendChatMessage} />
                    </div>
                : 
                    <div className={[
                            styles.messageBubble,
                            message.isResponse ? styles.responseBubble : styles.sentMessageBubble].join(" ")}>
                        {message.content}
                    </div>
            }
            {message.isResponse && message.username ?
                    <div>
                        <LetteredUserCircle
                            backgroundColor={variables.primaryBackgroundColor}
                            username={message.username} 
                            icon={faRobot} />
                    </div>
                :
                    null
            }
        </div>
    );
};